import EditModal from 'modules/teams/components/EditModal'
import TeamModal from 'modules/teams/components/TeamModal'

const EditTeamModal = () => <TeamModal modalComponent={EditModal} />

export default EditTeamModal
